import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthenticatedGuard  {
  constructor(public authenticationService: AuthenticationService, public router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const isLoggedIn = this.authenticationService.isLoggedIn;
    console.log(`---> AuthenticatedGuard canActivate called and IsLoggedIn: ${isLoggedIn}`);
    if (!isLoggedIn) {
      this.router.navigate(['login']);
    }
    return true;
  }
}
